import { format, formatDistanceToNow, isValid, parseISO } from "date-fns";

export function fmtDate(v) {
    if (!v) return "—";
    const d = typeof v === "string" ? parseISO(v) : v;
    return isValid(d) ? format(d, "dd MMM yyyy") : "—";
}

export function fmtDateTime(v) {
    if (!v) return "—";
    const d = typeof v === "string" ? parseISO(v) : v;
    return isValid(d) ? format(d, "dd MMM yyyy, HH:mm") : "—";
}

export function fromNow(v) {
    if (!v) return "";
    const d = typeof v === "string" ? parseISO(v) : v;
    return isValid(d) ? formatDistanceToNow(d, { addSuffix: true }) : "";
}

export function fmtINR(n) {
    if (n === null || n === undefined || Number.isNaN(Number(n))) return "₹0";
    return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
    }).format(Number(n));
}

export const STATUS_STYLES = {
    created: "bg-slate-50 text-slate-700 border-slate-200",
    assigned: "bg-sky-50 text-sky-700 border-sky-200",
    in_progress: "bg-amber-50 text-amber-800 border-amber-200",
    submitted_for_review: "bg-violet-50 text-violet-700 border-violet-200",
    returned_for_rework: "bg-orange-50 text-orange-800 border-orange-200",
    review: "bg-violet-50 text-violet-700 border-violet-200",
    completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
    closed: "bg-slate-100 text-slate-500 border-slate-200",
};

export const PRIORITY_STYLES = {
    low: "bg-slate-50 text-slate-600 border-slate-200",
    medium: "bg-sky-50 text-sky-700 border-sky-200",
    high: "bg-amber-50 text-amber-800 border-amber-200",
    urgent: "bg-rose-50 text-rose-700 border-rose-200",
};

export const COMPLIANCE_COLORS = {
    GST: "bg-blue-50 text-blue-700 border-blue-200",
    ITR: "bg-emerald-50 text-emerald-700 border-emerald-200",
    TDS: "bg-amber-50 text-amber-800 border-amber-200",
    ROC: "bg-violet-50 text-violet-700 border-violet-200",
    Audit: "bg-rose-50 text-rose-700 border-rose-200",
    PF: "bg-cyan-50 text-cyan-700 border-cyan-200",
    ESI: "bg-teal-50 text-teal-700 border-teal-200",
    Custom: "bg-slate-50 text-slate-700 border-slate-200",
};
